var map = {
	"./arquero.png": 819,
	"./caballero.png": 663,
	"./mago.png": 804,
	"./monster-heart-phase1.png": 748,
	"./monster-heart-phase2.png": 327,
	"./monster-heart-phase3.png": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;